export default __webpack_public_path__ + "static/media/app-homepage-mockup.1eae47e3.png";